import { cva } from 'class-variance-authority'

import { cn } from '@/lib/ui/style-helpers'

export const buttonVariants = cva(
  cn(
    'ring-offset-background hover:no-underline focus-visible:ring-ring inline-flex items-center justify-center rounded font-light transition-colors focus-visible:outline-none focus-visible:ring-offset-2 disabled:pointer-events-none text-nowrap',
    '!text-label-default',
  ),
  {
    variants: {
      variant: {
        default: cn(
          'bg-main-background-interactive-primary-default',
          'hover:bg-main-background-interactive-primary-hover',
          'disabled:bg-main-background-interactive-primary-disabled',
          'disabled:text-main-foreground-disabled',
          'active:bg-main-background-interactive-primary-pressed',
        ),
        secondary: cn(
          'bg-main-background-interactive-secondary-default',
          'hover:bg-main-background-interactive-secondary-hover',
          'disabled:bg-main-background-interactive-secondary-disabled',
          'disabled:text-main-foreground-disabled',
          'active:bg-main-background-interactive-secondary-default',
        ),
        outline: cn(
          'border border-main-border-semiBold',
          'shadow-outline',
          'text-main-foreground-primary',
          'hover:bg-palette-opacity-gray-lighter',
          'disabled:border-main-border-semiBold',
          'disabled:bg-palette-opacity-gray-light',
          'disabled:text-main-foreground-disabled',
          'active:bg-palette-opacity-gray-light',
        ),
        ghost: cn(
          'text-main-foreground-primary',
          'hover:bg-palette-opacity-gray-lighter',
          'disabled:text-main-foreground-disabled',
          'active:bg-palette-opacity-gray-lighter',
        ),
        'ghost-secondary': cn(
          'text-main-foreground-tertiary',
          'hover:bg-palette-opacity-gray-lighter',
          'disabled:text-main-foreground-disabled',
          'active:bg-palette-opacity-gray-light',
        ),
        destructive: cn(
          'bg-main-background-interactive-destructive-default',
          'text-main-foreground-white',
          'hover:bg-main-background-interactive-destructive-hover',
          'disabled:bg-main-background-interactive-destructive-disabled',
          'active:bg-main-background-interactive-destructive-pressed',
        ),
        link: cn(
          'text-main-foreground-accent',
          'hover:underline',
          'disabled:text-main-foreground-disabled',
        ),
        text: cn('hover:text-opacity-50', 'text-main-foreground-secondary'),
        highlight: cn(
          'bg-main-background-interactive-primary-default',
          '!text-label-large',
          'text-main-foreground-inverse',
          'border-2 border-palette-white',
          'shadow-highlight',
          'hover:bg-main-background-interactive-primary-hover',
          'disabled:bg-main-background-interactive-primary-disabled',
          'disabled:text-main-foreground-disabled',
          'active:bg-main-background-interactive-primary-pressed',
        ),
        promotion: cn(
          'border border-main-border-semiBold',
          'shadow-outline',
          'bg-main-background-interactive-list-selected',
          'text-main-foreground-accent',
          'border-main-border-accent',
          'hover:bg-main-background-interactive-list-selectedHover',
          'disabled:bg-main-background-interactive-list-disabled',
          'disabled:border-main-border-default',
          'disabled:text-main-foreground-disabled',
        ),
      },
      size: {
        default: 'h-8 px-3 py-1.5 space-x-2',
        sm: 'py-1 px-1.5 space-x-1 !text-label-small',
        md: 'py-1 h-8 px-3.75',
        lg: 'h-10 px-4 py-2 space-x-2',
        icon: 'size-8',
        'icon-sm': 'size-6',
      },
      position: {
        default: '',
        sticky: 'sticky bottom-8 z-max',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
      position: 'default',
    },
    compoundVariants: [
      {
        variant: 'text',
        size: 'default',
        className: 'p-0',
      },
      {
        variant: ['secondary'],
        size: ['lg', 'sm', 'md', 'default'],
        className: 'active:bg-main-background-interactive-secondary-pressed',
      },
      {
        variant: ['default'],
        size: ['default', 'sm', 'md', 'lg', 'icon', 'icon-sm'],
        className: 'text-main-foreground-inverse',
      },
      {
        variant: ['highlight'],
        size: ['default', 'sm', 'md', 'lg', 'icon', 'icon-sm'],
        className: 'px-4 py-2 space-x-2',
      },
      {
        variant: ['link'],
        size: ['default', 'sm', 'md', 'lg', 'icon', 'icon-sm'],
        className: 'text-main-foreground-accent',
      },
    ],
  },
)
